import {baseUrl} from "@maya/helper/ui-shared";
import {FaFacebookSquare, FaLinkedin} from "react-icons/fa";
import {FaXTwitter} from "react-icons/fa6";

const Footer = () => {
  return (
    <div className="bg-[whitesmoke]">
      <div className="container mx-auto p-4 md:p-8 lg:px-16 xl:px-70">
        <div className="flex flex-wrap justify-between gap-6 md:gap-8">
          <div className="space-y-3">
            <h6 className="text-neutral-500 text-md font-semibold">ABOUT</h6>
            <ul className="space-y-2 text-gray-700">
              <li>
                <a
                  href={`${baseUrl}/index.html#!#page-top`}
                  className="text-sm hover:text-blue-500"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/about.html`}
                  className="text-sm hover:text-blue-500"
                >
                  Our Story
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/about.html#!#1`}
                  className="text-sm hover:text-blue-500"
                >
                  Our Team
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/about.html#!#2`}
                  className="text-sm hover:text-blue-500"
                >
                  Our Advisor
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/about.html#!#3`}
                  className="text-sm hover:text-blue-500"
                >
                  Our Investors
                </a>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h6 className="text-neutral-500 text-md font-semibold">OTHERS</h6>
            <ul className="space-y-2  text-gray-700">
              <li>
                <a
                  href={`${baseUrl}/media.html`}
                  className="text-sm hover:text-blue-500"
                >
                  Media
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/careers.html`}
                  className="text-sm hover:text-blue-500"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/faq.html`}
                  className="text-sm hover:text-blue-500"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/our-core-principles.html`}
                  className="text-sm hover:text-blue-500"
                >
                  Our Principles
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/privacy-policy.html`}
                  className="text-sm hover:text-blue-500"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href={`${baseUrl}/terms-and-conditions.html`}
                  className="text-sm hover:text-blue-500"
                >
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h6 className="text-neutral-500 text-md font-semibold">ADDRESS</h6>
            <ul className="text-gray-700">
              <li className="text-sm space-y-2">
                <div>Datasigns Technologies Pvt. Ltd.,</div>
                <div>NOVA MILLER, #333,</div>
                <div>Thimmiah Road, Vasanth Nagar,</div>
                <div>Bengaluru - 560052</div>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h6 className="text-neutral-500 text-md font-semibold">CONTACT</h6>
            <ul className="space-y-2  text-gray-700">
              <li className="text-sm">+91-90199-00199</li>
              <li className="text-sm">support@myshubhlife.com</li>
              <li className="flex space-x-4 pt-2">
                <a
                  href="https://www.facebook.com/MyShubhLifeApp/"
                  target="_blank"
                  className=" text-blue-500" rel="noreferrer"
                >
                  <FaFacebookSquare size={22} />
                </a>
                <a
                  href="https://www.linkedin.com/company/myshubhlife/"
                  target="_blank"
                  className=" text-blue-500" rel="noreferrer"
                >
                  <FaLinkedin size={22} />
                </a>
                <a
                  href="https://twitter.com/myshubhlife"
                  target="_blank"
                  className=" text-blue-500" rel="noreferrer"
                >
                  <FaXTwitter size={21} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-gray-700 py-3">
        <p className="text-white text-sm text-center">
          © {new Date().getFullYear()} MyShubhLife. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
